import { PHOTO_COMMENT_AUTHOR, PHOTO_COMMENT_ID, PHOTO_COMMENT_TEXT } from "../constants"

class CommentEntity {
  constructor({ id, authorName, text, createdAt }) {
    this.id = id
    this.authorName = authorName
    this.text = text
    this.createdAt = createdAt
  }

  copyWith({ id, timestamp, authorName, text }) {
    return new CommentEntity({
      id: id === undefined ? this.id : id,
      timestamp: timestamp === undefined ? this.createdAt : timestamp,
      authorName: authorName === undefined ? this.authorName : authorName,
      text: text === undefined ? this.text : text,
    })
  }

  static fromJson(json) {
    return new CommentEntity({
      id: json.id,
      createdAt: json.created_at ? Date.parse(json.created_at) : null,
      authorName: json.author_name,
      text: json.body,
    })
  }

  static fromHtmlElement(htmlElement) {
    let elementWithId
    if (htmlElement.dataset.commentId) {
      elementWithId = htmlElement
    } else {
      elementWithId = htmlElement.querySelector(PHOTO_COMMENT_ID)
    }

    const authorElement = htmlElement.querySelector(PHOTO_COMMENT_AUTHOR)
    const bodyElement = htmlElement.querySelector(PHOTO_COMMENT_TEXT)

    return new CommentEntity({
      id: Number(elementWithId?.dataset.commentId) || null,
      createdAt: null,
      authorName: authorElement?.textContent || "",
      text: bodyElement?.textContent || "",
    })
  }
}

export default CommentEntity
